module.exports = __webpack_public_path__ + "img/discover.08c35ce.png";